import React from 'react'
import styled from 'styled-components'

const SkeletonBroadcastWeekDays: React.FC = () => {
  return (
    <StyledSkeletonWrapper>
      <StyledSkeletonBroadcastWeekDays>
        <div className="skeleton" />
      </StyledSkeletonBroadcastWeekDays>
    </StyledSkeletonWrapper>
  )
}

const StyledSkeletonWrapper = styled.div`
  margin-bottom: 50px;
  @media screen and (max-width: 768px) {
    margin-bottom: 20px;
  }
`

const StyledSkeletonBroadcastWeekDays = styled.div`
  width: 100%;
  height: 120px;
  z-index: 1;
  border-radius: 6px;
  .skeleton {
    width: 100%;
    height: 100%;
    background-color: ${(props) => props.theme.skeleton};
    background-image: ${(props) => props.theme.skeletonGradation};
    background-size: 40px 100%;
    background-repeat: no-repeat;
    background-position: left -40px top 0;
    animation: shine 1s ease infinite;
    border-radius: inherit;
  }
  @keyframes shine {
    to {
      background-position: right -40px top 0;
    }
  }
  @media screen and (max-width: 768px) {
    height: 80px;
  }
`
export default SkeletonBroadcastWeekDays
